import type { LocalRefLabel } from "@/utils/i18n/t11n"
import { isNullOrUndefined } from "@/utils/ts-utils"
import type { Prettify } from "@/utils/types/utils"

type RelInfo = {
  function?: string | null
  isDefault?: boolean | null
  role?: LocalRefLabel | null
  rank?: LocalRefLabel | null
  dateOfEntry?: string
  dateOfLeaving?: string | null
  metadatas?: { [k: string]: string }
  isPublished?: boolean | null
  isPublishedInDirectory?: boolean | null
  status?: LocalRefLabel | null
}

type Rel<T> = {
  id: string
  cluster?: T
} & RelInfo

type ExtendedRel<T> = Prettify<T & RelInfo>

export const getRelatedCluster = <TCluster>(rel: Rel<TCluster>) => {
  return {
    ...rel.cluster,
    function: "function" in rel ? rel.function : undefined,
    isDefault: "isDefault" in rel ? rel.isDefault : undefined,
    role: "role" in rel ? rel.role : undefined,
    rank: "rank" in rel ? rel.rank : undefined,
    dateOfEntry: "dateOfEntry" in rel ? rel.dateOfEntry : undefined,
    dateOfLeaving: "dateOfLeaving" in rel ? rel.dateOfLeaving : undefined,
    metadatas: "metadatas" in rel ? rel.metadatas : undefined,
    isPublished: "isPublished" in rel ? rel.isPublished : undefined,
    isPublishedInDirectory:
      "isPublishedInDirectory" in rel ? rel.isPublishedInDirectory : undefined,
    status: "status" in rel ? rel.status : undefined,
  } as NonNullable<ExtendedRel<TCluster>>
}

export const getRelatedClusters = <TCluster>(rels?: Rel<TCluster>[]) => {
  return isNullOrUndefined(rels) ? undefined : rels.map(rel => getRelatedCluster(rel))
}

export const getDefaultRelatedCluster = <TCluster>(
  rels?: Rel<TCluster>[],
  filterOn?: { [k in keyof Rel<TCluster>]?: Rel<TCluster>[k] }
) => {
  const filters = (
    isNullOrUndefined(filterOn) ? [] : Object.keys(filterOn)
  ) as (keyof Rel<TCluster>)[]

  const r = (rels ?? []).filter(rl => {
    let ok = true
    filters.map(f => {
      if (rl[f] !== filterOn?.[f]) ok = false
    })
    return ok
  })

  for (const rel of r) {
    if (rel.isDefault) return getRelatedCluster(rel)
  }

  return isNullOrUndefined(r[0]) ? undefined : getRelatedCluster(r[0])
}
